module.exports = __webpack_public_path__ + "img/image-logo.ecb9b73b.svg";